import {
	CreateDrawerFormProps,
	FormDrawerContentProps,
	I18nFormDrawer,
	I18nFormDrawerContent,
	I18nFormFetchDrawer,
	I18nTextField,
	UpdateDrawerFormProps,
	useDynamicConfig,
	validateEachLanguage,
} from "@dgs/core";
import { FormikErrors } from "formik";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { targetGroupService } from "../shared/api/targetGroupService";
import { TargetGroupFormValues } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: TargetGroupFormValues) => {
		const errors: FormikErrors<TargetGroupFormValues> = {};
		return {
			...errors,
			...validateEachLanguage<TargetGroupFormValues["translations"][number]>(values.translations, (_, translation) => {
				const errors: Record<string, any> = {};
				if (!translation.name) {
					errors.name = t("Field is required");
				}
				return errors;
			}),
		};
	};
};

const emptyTranslation = { name: "" };

const TargetGroupFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<I18nFormDrawerContent {...props} emptyTranslation={emptyTranslation}>
			<I18nTextField name="name" label={t("Name")} required="onlyOnMainForm" />
		</I18nFormDrawerContent>
	);
};

export const TargetGroupCreateDrawer: FC<CreateDrawerFormProps<TargetGroupFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const { languageSettings } = useDynamicConfig();

	const initialValues: TargetGroupFormValues = useMemo(
		() => ({
			translations: [{ locale: languageSettings.fallback, name: "" }],
		}),
		[languageSettings.fallback],
	);

	return (
		<I18nFormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create target group")}
			validate={validate}
			renderForm={(formProps) => <TargetGroupFormDrawerContent {...formProps} {...props} />}
		/>
	);
};

export const TargetGroupUpdateDrawer: FC<UpdateDrawerFormProps<TargetGroupFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<I18nFormFetchDrawer
			{...props}
			title={t("Edit target group")}
			queryFn={() => targetGroupService.show(props.id).then((x) => x.data.data)}
			queryKey={targetGroupService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => <TargetGroupFormDrawerContent {...props} {...formProps} />}
		/>
	);
};
